import PrivateLayout from '@/layouts/PrivateLayout.vue';
import SettingsPage from '@/pages/SettingsPage.vue';

export default [
  {
    path: '/settings',
    component: PrivateLayout,
    children: [
      {
        path: '',
        name: 'Settings',
        component: SettingsPage,
      },
    ],
    meta: { requiresAuth: true, roles: ['superuser', 'user'] },
  },
];
